import { Box, Center, Heading, Link, Text } from "@chakra-ui/react";

import analyticsInstance from "../config/analytics";

const footerLinkStyles = {
  display: "block",
  my: "0.25em",
  _hover: { textDecoration: "none" },
};

function Footer() {
  return (
    <Box as="footer" pt="4em" pb="2em" bgColor="#eeeeee">
      <Center gap="8em" w="full" alignItems="top">
        <Box>
          <Heading size="md" mb="0.5em">
            Contacts
          </Heading>

          <Link
            href="mailto:help@btfdca.finance"
            isExternal
            sx={footerLinkStyles}
            onClick={() => {
              analyticsInstance.track("FooterContactClicked");
            }}
          >
            📧 Email
          </Link>

          <Link
            href="https://twitter.com/btfdca_finance"
            isExternal
            sx={footerLinkStyles}
            onClick={() => {
              analyticsInstance.track("FooterTwitterClicked");
            }}
          >
            🐦 Twitz
          </Link>

          <Link
            href="https://discord.gg/AcgfRqukQt"
            isExternal
            sx={footerLinkStyles}
            onClick={() => {
              analyticsInstance.track("FooterDiscordClicked");
            }}
          >
            🤿 Discord
          </Link>
        </Box>

        <Box>
          <Heading size="md" mb="0.5em">
            Unrelated
          </Heading>

          <Link
            href="https://banner-nfts.com"
            isExternal
            sx={footerLinkStyles}
            _hover={{ textDecoration: "none" }}
            onClick={() => {
              analyticsInstance.track("FooterBannerNFTsClicked");
            }}
          >
            ✌️ Mint my NFT
          </Link>
        </Box>
      </Center>

      <Center mt="4em">
        <Text fontSize="xs">Copyright © Since 2023 by BTFDCA</Text>
      </Center>
    </Box>
  );
}

export default Footer;
